module.exports = __webpack_public_path__ + "img/file.3d26c5ad.svg";